export const statusColors = {
  notStarted: '#C4C4C4',
  started: '#4058F2',
  completed: '#72C59F',
  canceled: '#DD5633',
};
